import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { FundService } from 'src/app/services/fund/fund.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-dashboard-fund-approval-transfers',
  templateUrl: './dashboard-fund-approval-transfers.component.html',
  styleUrls: ['./dashboard-fund-approval-transfers.component.scss'],
})
export class DashboardFundApprovalTransfersComponent implements OnInit {
  loading = true;
  data;

  constructor(
    public fundService: FundService,
    private api: ApiService,
    private route: ActivatedRoute,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    if (this.fundService.fundData.transfer) {
      this.data = this.fundService.fundData.transfer;
      this.loading = false;
    } else {
      this.getFundData();
    }
  }

  formatPhone(ddi: string, number: string) {
    return `+${ddi} ${number}`;
  }

  async getFundData() {
    try {
      const data = await this.api.get({
        route: 'api/v2/approvals/version/',
        params: {
          fund: this.route.snapshot.params.id,
          tab: 'transference',
        },
        token: true,
      });

      const fund = { ...data };

      this.data = fund[0].fund[0];

      this.fundService.fundData = {
        ...this.fundService.fundData,
        transfer: fund[0].fund[0],
      };
    } catch (error) {
      this.toast.show(
        'error',
        'Erro',
        'Erro ao carregar transferência: ' + error
      );
    }

    this.loading = false;
  }
}
